import axios from 'axios';

export const getFetch = async (url) => {
  try {
    const response = await axios.get(url, {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
    return response.data
  } catch (error) {
    return error
  }

}





// WEBPACK FOOTER //
// ./src/tools/fetch.js